'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _CloseSecondary = require('@scoir/brand-icons/dist/CloseSecondary');

var _CloseSecondary2 = _interopRequireDefault(_CloseSecondary);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DismissableItem = function DismissableItem(_ref) {
    var children = _ref.children,
        onDismiss = _ref.onDismiss,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('ct-dismissable-item-comp', className) },
        _react2.default.createElement(
            'div',
            { className: 'dismissable-item-children' },
            children
        ),
        _react2.default.createElement(
            _Button2.default,
            { className: 'dismissable-item-button',
                'aria-label': 'Dismiss Item',
                onClick: onDismiss },
            _react2.default.createElement(_CloseSecondary2.default, null)
        )
    );
};
DismissableItem.propTypes = {
    children: _propTypes2.default.any.isRequired,
    className: _propTypes2.default.string,
    onDismiss: _propTypes2.default.func.isRequired
};

exports.default = DismissableItem;
//# sourceMappingURL=index.js.map